//external
import React from "react";
import { connect } from "react-redux";

//components
import TurfDropoffMapModalLegacy from "./TurfDropoffMapModalLegacy";
import TurfDropoffMapModalUber from "./TurfDropoffMapModalUber";

//actions and calls
import { updateDoorCrew } from "../../store/actions";

// picks the Uber (validated, drivable addresses only) or legacy (Google Places,
// but also lets you drop a pin that doesn't resolve to a strict address --
// e.g. "meet by the north gate") address-search path based on the crew's
// `useUber` flag. Both paths share their map/card UI via TurfDropoffMapModalBase.
const TurfDropoffMapModal = (props) => {
  const DropoffModal = props.useUber
    ? TurfDropoffMapModalUber
    : TurfDropoffMapModalLegacy;

  return <DropoffModal {...props} />;
};

const mapStateToProps = (state) => ({
  crews: state.doorCrews.data,
  loading: state.doorCrews.loading,
  error: state.doorCrews.error,
});

const mapDispatchToProps = (dispatch) => ({
  updateCrew: (data) => dispatch(updateDoorCrew(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TurfDropoffMapModal);
